const WIDTH_SP = 769;
/* html読み込み直後の共通処理
-------------------------------------------------- */
document.addEventListener('DOMContentLoaded', function(){
  // ページの表示
  var body = document.querySelector("body");
  body.style.opacity = "1";
  body.classList.remove("preload");

  // retina対応
  console.log("retina set");
  const retinaCheck = window.devicePixelRatio;
  let retinaimg = "";
  if (retinaCheck >= 2) {
    let target = document.getElementsByClassName('retina');
    for (let i = 0; i < target.length; i++) {
      if (target[i].getAttribute('src')) {
        retinaimg = target[i].getAttribute('src').replace(/\.(?=(?:png|jpg|jpeg).*$)/i, '--2x.');
      } else if (target[i].dataset.src) { // lazyload用
        retinaimg = target[i].dataset.src.replace(/\.(?=(?:png|jpg|jpeg).*$)/i, '--2x.');
      }
      target[i].setAttribute('srcset', retinaimg + ' 2x');
    }
  }

  /* FAQ開閉 ------- */
  const moreBtn = Array.from(document.querySelectorAll('.faq__item--q'));

  moreBtn.forEach((item) => {
    item.addEventListener('click', function () {
      this.classList.toggle('is-on');
      const target = this.nextElementSibling;

      if (target.style.maxHeight) {
        target.style.maxHeight = null;
      } else {
        target.style.maxHeight = target.scrollHeight + 'px';
      }
    });
  });

  /* スライダー ------- */
  // mv
  let mvSwiper = new Swiper('.mv__slide', {
    slidesPerView: 4.8,
    spaceBetween: 0,
    spaceBetween: 0,
    autoplay: { delay: 4000 },
    //autoplay: { delay: 350 },
    roundLengths: true,
    centeredSlides: true,
    loop: true,
    // レスポンシブ
    breakpoints: {
      768: {
        slidesPerView: 1.2,
      }
    }
  });

  /* voice ------- */
  let voiceSwiper = new Swiper('.voice__slide', {
    slidesPerView: 2,
    slidesPerGroup: 2,
    spaceBetween: 0,
    spaceBetween: 0,
    centeredSlides: false,
    autoplay: { delay: 10000 },
    //autoplay: { delay: 350 },
    roundLengths: true,
    centeredSlides: false,
    loop: true,
    navigation: {
      nextEl: ".voice_slider_arrow-r",
      prevEl: ".voice_slider_arrow-l"
    },
    // レスポンシブ
    breakpoints: {
      768: {
        slidesPerView: 1,
        slidesPerGroup: 1,
        centeredSlides: true,
      }
    }
  });

  /* 固定CTA */
  const startPos = 200;
  const fixedCta = document.getElementById("fixed-cta");
  window.addEventListener("scroll", function () {
    const endPos = document.getElementById("product").getBoundingClientRect().top - (window.innerHeight / 2);
    const scroll = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;

    if (scroll > startPos && endPos > 0) {
      fixedCta.classList.add("show");
    } else {
      fixedCta.classList.remove("show");
    }
  });
});

// スムーススクロール
$(function(){
  $('a[href^="#"]').click(function(){
    var adjust = 0;
    var speed = 500; // ミリ秒
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top + adjust;
    $('body,html').animate({scrollTop:position}, speed, 'swing');
    return false;
  });
});

/* 要素のフェード
-------------------------------------------------- */
window.addEventListener("load", doFade);
window.addEventListener("scroll", doFade);
function doFade() {
  let fadeInTarget = document.querySelectorAll(".js-fade-in");
  for (let i = 0; i < fadeInTarget.length; i++) {
    var elem = fadeInTarget[i];
    var rect = elem.getBoundingClientRect().top;
    var scroll = window.pageYOffset || document.documentElement.scrollTop;
    var offset = rect + scroll;
    var windowHeight = window.innerHeight; // 現在のブラウザの高さ
    // 実行時のディレイ
    var delay = elem.dataset.delay == undefined ? 0 : elem.dataset.delay;
    // 位置に関係なくload時に実行するかどうか
    var isLoad = elem.dataset.load == undefined ? false : elem.dataset.load;
    // 実行する位置
    var positionPc = elem.dataset.positionPc == undefined ? 200 : elem.dataset.positionPc;
    var positionSp = elem.dataset.positionSp == undefined ? 0 : elem.dataset.positionSp;
    var position = document.body.clientWidth > 751 ? positionPc : positionSp;
    var dispPosition = offset - windowHeight + position; // 実行位置
    // 速度
    var duration = elem.dataset.duration == undefined ? 1.5 : elem.dataset.duration;

    if (scroll > dispPosition || isLoad) {
      elem.classList.add("js-scroll-in");
      elem.style.transitionDelay = delay + "s";
      elem.style.transitionDuration = duration + "s";
    }
  }
}

/* scrollでis-onクラスを付与する
-------------------------------------------------- */
window.addEventListener("load", setIsOn);
window.addEventListener("scroll", setIsOn);
function setIsOn() {
  let fadeInTarget = document.querySelectorAll(".js-scroll");
  for (let i = 0; i < fadeInTarget.length; i++) {
    const elem = fadeInTarget[i];
    const rect = elem.getBoundingClientRect().top;
    const scroll = window.pageYOffset || document.documentElement.scrollTop;
    const offset = rect + scroll;
    const windowHeight = window.innerHeight; // 現在のブラウザの高さ

    // 位置に関係なくload時に実行するかどうか
    const isLoad = elem.dataset.load == undefined ? false : elem.dataset.load;
    // 実行する位置
    const dispPosition = offset - windowHeight; // 実行位置

    if (scroll > dispPosition || isLoad) {
      elem.classList.add("is-on");
    }
  }
}

/* CTA背景スクロール
-------------------------------------------------- */
/*window.addEventListener("load", scrollAnimationFunc);
window.addEventListener("scroll", scrollAnimationFunc);
window.addEventListener("resize", scrollAnimationFunc);

function scrollAnimationFunc() {

  let paraElem = document.getElementsByClassName("cta");

  for (var i = 0; i < paraElem.length; i++) {
    let triggerMargin = 300;
    let target = paraElem[i];
    let img = target.getElementsByClassName("cta__bg");

    // 動かす幅を取得(画像の高さ-コンテンツの高さ)
    const adjustment = 100; // 動き調整分
    let paraMoveSize = img[0].clientHeight - target.clientHeight + adjustment; // 余白分

    // スクロール位置（スタート、エンド、カレント）
    let scrollStart = window.pageYOffset + target.getBoundingClientRect().top - window.innerHeight;
    let scrollEnd = window.pageYOffset + target.getBoundingClientRect().top + target.clientHeight;
    let nowPosition = docScrollElem.scrollTop;
    // ブラウザの高さと要素の高さ
    let browserH = window.innerHeight;
    let targetPos = target.getBoundingClientRect().top;
    // 上下の移動幅
    let moveRange = scrollEnd - scrollStart;
    // 1ピクセルにつき移動する量
    let moveByPic = paraMoveSize / moveRange;

    if (nowPosition > scrollStart && nowPosition < scrollEnd) {
      let movePosition = (browserH - targetPos - adjustment) * moveByPic * -1;
      img[0].style.transform = "translate(-50%," + movePosition + "px)";
    }
  }
};
*/

/** スクロール位置取得のためのfunction */
/* var docScrollElem = (function () {
  if ("scrollingElement" in document) {
    return document.scrollingElement;
  } else if (navigator.userAgent.toLowerCase().indexOf("webkit") > -1) {
    return document.body;
  } else if ("documentElement" in document) {
    return document.documentElement;
  } else {
    return document.body;
  }
})();
 */